import * as Actiontypes from '../../types/receipt';

export const setReceipts = (data) => {
    // console.log('action', data)
    return {
        type: Actiontypes.SET_RECEIPTS,
        payload: data
    }
}